import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    // 전기요금
    electricityPaymentInpt: {
      paymtInstiCd: "", //납부기관코드
      paymtInstiName: "", //납부기관명
      prCd: "", //납부자코드
    },
    electricityPaymentPro1: {}, // 전기요금 예비거래 출력값
    electricityPaymentPro2: {}, // 전기요금 본거래 출력값

    waterPaymentInpt: {
      //수도요금 납부 정보
      paymtInstiCd: "", //납부기관코드
      paymtInstiName: "", //납부기관명
      prCd: "", //납부자코드
    },
    waterPaymentPro1: {}, // 수도요금 예비거래 출력값
    waterPaymentPro2: {}, // 수도요금 본거래 출력값
  };
};

const billPaymentInpt = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default billPaymentInpt;
